import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import {Form} from 'formik';
import FieldSelectModal from '../../components/FieldSelectModal';
import FieldSelect from '../../components/FieldSelect';
import Button from '../../components/Button';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step5View = ({
                     loadOptions: {
                       practiceArea,
                       jobTitle,
                       customerTypes,
                       workRegion,
                       workCapacity
                     },
                     values,
                     onChange: {
                       practiceAreaChange,
                       customerChange,
                       workRegionChange
                     },
                     isValid,
                   }) => {
  const {formatMessage} = useIntl();
  const areaOfPracticePlaceholder = formatMessage({
    id: 'step5.form.areaOfPractice.placeholder',
    defaultMessage: 'Write area of practice'
  });
  const rolePlaceholder = formatMessage({
    id: 'step5.form.role.placeholder',
    defaultMessage: 'Write role name'
  });

  return (
    <Form className={styles.formContainer}>
      <div className={styles.input}>
        <FieldSelectModal
          fieldId='practiceArea'
          loadOptions={practiceArea}
          onChange={practiceAreaChange}
          label={(
            <FormattedMessage
              id='step5.form.areaOfPractice.label'
              defaultMessage='Area of practice'
            />
          )}
          placeholder={areaOfPracticePlaceholder}
          modalHeaderLabel={(
            <FormattedMessage
              id='step5.form.areaOfPractice.modal.title'
              defaultMessage='Choice of your area of practice'
            />
          )}
          optionsListLabel={(
            <FormattedMessage
              id='step5.form.areaOfPractice.modal.options.label'
              defaultMessage='Select a area of practice name from the list:'
            />
          )}
        />
      </div>
      <div className={styles.input}>
        <FieldSelectModal
          fieldId='job'
          loadOptions={jobTitle}
          label={(
            <FormattedMessage
              id='step5.form.role.label'
              defaultMessage='Role'
            />
          )}
          placeholder={rolePlaceholder}
          modalHeaderLabel={(
            <FormattedMessage
              id='step5.form.role.modal.title'
              defaultMessage='Choice of your role'
            />
          )}
          optionsListLabel={(
            <FormattedMessage
              id='step5.form.role.modal.options.label'
              defaultMessage='Select a role name from the list:'
            />
          )}
          disabled={!values.practiceArea || values.practiceArea.value === null}
        />
      </div>
      <div className={styles.input}>
        <FieldSelect
          fieldId='clients'
          loadOptions={customerTypes}
          label={(
            <FormattedMessage
              id='step5.form.customers.label'
              defaultMessage='Who are your customers'
            />
          )}
          modalHeaderLabel={(
            <FormattedMessage
              id='step5.form.customers.modal.title'
              defaultMessage='Choice of your customers'
            />
          )}
          optionsListLabel={(
            <FormattedMessage
              id='step5.form.customers.modal.options.label'
              defaultMessage='Select customers from the list:'
            />
          )}
          isMulti
          onChange={customerChange}
        />
      </div>
      <div className={styles.input}>
        <FieldSelect
          fieldId='area'
          loadOptions={workRegion}
          label={(
            <FormattedMessage
              id='step5.form.areaOfActivity.label'
              defaultMessage='What is your area of activity'
            />
          )}
          modalHeaderLabel={(
            <FormattedMessage
              id='step5.form.areaOfActivity.modal.title'
              defaultMessage='Choice of your area of activity'
            />
          )}
          optionsListLabel={(
            <FormattedMessage
              id='step5.form.areaOfActivity.modal.options.label'
              defaultMessage='Select an area of activity from the list:'
            />
          )}
          isMulti
          onChange={workRegionChange}
        />
      </div>
      <div className={styles.input}>
        <FieldSelect
          fieldId='scopeOfWork'
          loadOptions={workCapacity}
          label={(
            <FormattedMessage
              id='step5.form.scope.label'
              defaultMessage='What is your scope of work'
            />
          )}
          modalHeaderLabel={(
            <FormattedMessage
              id='step5.form.scope.modal.title'
              defaultMessage='Choice of your scope of work'
            />
          )}
          optionsListLabel={(
            <FormattedMessage
              id='step5.form.scope.modal.options.label'
              defaultMessage='Select a scope of work from the list:'
            />
          )}
        />
      </div>

      <Button
        type='submit'
        label={(
          <FormattedMessage
            id='common.form.button.save'
            defaultMessage='Save and continue'
          />
        )}
      />
      {!isValid && <ErrorValidation />}
    </Form>
  )
};

Step5View.propTypes = {
  loadOptions: PropTypes.shape({
    practiceArea: PropTypes.func,
    jobTitle: PropTypes.func,
    customerTypes: PropTypes.func,
    workRegion: PropTypes.func,
    workCapacity: PropTypes.func
  }),
  values: PropTypes.object,
  isValid: PropTypes.bool,
  onChange: PropTypes.shape({
    practiceAreaChange: PropTypes.func,
    customerChange: PropTypes.func,
    workRegionChange: PropTypes.func,
  }),
};

export default Step5View;
